import { Major } from '../builders/major_builder';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { ITransferMajorsDatasource } from '../datasources/transfer_majors_datasource';

export interface ITransferMajorsFoundQueryResult {
  majors: Major[];
  hasMore: boolean;
}
export class TransferMajorsFoundQuery implements IQuery {

  private _result: ITransferMajorsFoundQueryResult;

  constructor(QueryMediator: IQueryMediator,
    private ngTransferMajorsDatasource: ITransferMajorsDatasource) {
    QueryMediator.registerQuery(this, ngTransferMajorsDatasource);
  }

  run(): TransferMajorsFoundQuery {
    const foundResults = _.filter(this.ngTransferMajorsDatasource.read(), (major: Major): boolean => major.isFound);
    this._result = {
      majors: _(foundResults)
        .sortBy((major: Major) => major.searchOrdering)
        .value(),
      hasMore: this.ngTransferMajorsDatasource.model.hasMore
    }
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-transfer')
  .service('ngTransferMajorsFoundQuery', TransferMajorsFoundQuery);





// WEBPACK FOOTER //
// ./app/lib/transfer/queries/transfer_majors_found_query.ts